<!-- 医疗案例 -->
<template>
  <div class="case">
    <h4 class="current">您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 医院绩效管理系统</h4>
    <div class="article">
      <h5>医院培训考试系统</h5>
      <h4 class="smalltit">产品简介</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医学考试种类繁多，如对于医疗工作者的执业医师资格考试，护士执业资格考试，卫生专业技术资格考试等。全国各级医院日常进行的医护人员招聘考试，“三基”、“三严”考试等。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;索睿医院培训考试系统是为各医院的自我学习测试、内部考核、职称晋升考试等需要而量身定做的集学习、考试、管理于一体的无纸化在线考试系统，可实现
        <span class="boldblack" style="font-weight: bold; color: #333">
          出题、组卷、考试、评卷、成绩分析整个流程信息化、自动化管理</span
        >
        ，在提高考试效率的同时降低考试成本。其中在线考试模块采用试题库模式，可根据考试内容及要求选择对应的试题。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系统具有
        <span style="font-weight: bold; color: #333">随机组卷、专项练习、自动阅卷、数据统计、后台管理</span>
        等功能，可为用户节约大量纸张以及印刷、监考、阅卷、 录入数据的人工费用。
      </p>

      <h4 class="smalltit">产品特色</h4>
      <p>
        （一）整合各方知识资源，提供理想考试题库；<br />
        （二）应用于各类考试测评，显著提高考试通过率； <br />
        （三）形成高效自学途径，提升职业技能； <br />
        （四）精准的多维数据统计，评估准确； <br />
        （五）纳入评估考核体系，辅助人才队伍建设。
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
